/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {AbsctractProcessingLoadConf} from './absctractProcessingLoadConf';
import {AbstractLoadConf} from './abstractLoadConf';


export interface SqlProcessingLoadConf extends AbsctractProcessingLoadConf {
    destTable?: Array<string>;
    loads?: Array<AbstractLoadConf>;
    typeLoad?: string;
    contactType?: SqlProcessingLoadConf.ContactTypeEnum;
}
export namespace SqlProcessingLoadConf {
    export type ContactTypeEnum = 'CUSTOMER' | 'PROSPECT' | 'SUSPECT';
    export const ContactTypeEnum = {
        CUSTOMER: 'CUSTOMER' as ContactTypeEnum,
        PROSPECT: 'PROSPECT' as ContactTypeEnum,
        SUSPECT: 'SUSPECT' as ContactTypeEnum
    };
}
